import { PartyDetail } from "../types/common";
import {
    BesuProjectState,
    ProjectStateWithNestedStatus,
    ProjectStatus,
} from "../types/project";
import { UserRole } from "../types/userCurrent";

import { hasNestedClaimAction } from "./claim";
import { isUserContractor, isNodeDeveloper } from "./role";

export const getCounterEntity = (
    project: BesuProjectState,
    roles: UserRole[],
): PartyDetail | null => {
    const counterparty = isNodeDeveloper()
        ? project.mainContractors[0]
        : isUserContractor(roles)
        ? project.developer
        : null;
    if (!counterparty) {
        return null;
    }
    return {
        party: counterparty.displayName,
        account: {
            host: "",
            identifier: { id: counterparty.accountName },
            linearId: { id: counterparty.accountName },
            name: counterparty.accountName,
            participants: counterparty.wallet ? [counterparty.wallet] : [],
        },
    };
};

export const hasProjectAction = (
    roles: UserRole[],
    projectStatus: ProjectStatus,
): boolean => {
    return (
        isUserContractor(roles) &&
        projectStatus === ProjectStatus.PENDING_DELETE
    );
};

// TODO : consider to remove
export const hasNestedProjectAction = (
    roles: UserRole[],
    nestedProjectState: ProjectStateWithNestedStatus,
): boolean => {
    return (
        hasProjectAction(roles, nestedProjectState.projectState.status) ||
        nestedProjectState.claimStatuses.some((nestedClaimStatus) =>
            hasNestedClaimAction(roles, nestedClaimStatus),
        )
    );
};

export const isLtaProject = (value: string) => {
  if (value === '') return false;
  return value.endsWith("_LTA");
};